/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import autobind from "autobind-decorator";
import {BaseFieldViewer} from "./BaseFieldViewer";

export class JsonFieldViewer extends BaseFieldViewer {
    @autobind
    _render() {
        const { Value } = this.props;

        return Value != null ? <span className="pndlm-line-break">{JSON.stringify(Value, undefined, 2)}</span> : "";
    }
}
